// @ts-ignore
import { Component } from "@theme/component";
import {
  ThemeEvents,
  VariantSelectedEvent,
  VariantUpdateEvent,
} from "@theme/events";
import { morph } from "@theme/morph";

export class ServingInfo extends Component {
  requiredRefs = ["servingInfo"];

  connectedCallback() {
    super.connectedCallback();
    this.closestSection = this.closest(`.shopify-section, dialog`);
    this.skioPlanPicker =
      this.closestSection?.querySelector(".skio-plan-picker");

    console.log("servingInfo connected");

    const servingInfo = this.refs.servingInfo;

    if (!(servingInfo instanceof HTMLElement))
      throw new Error("Serving info not found");

    this.closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    );
    this.closestSection?.addEventListener(
      ThemeEvents.variantSelected,
      this.#handleVariantSelected
    );

    this.skioPlanPicker?.addEventListener(
      "skio:plan-picker:update",
      this.#handleSkioPlanPickerUpdate
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    );
    this.closestSection?.removeEventListener(
      ThemeEvents.variantSelected,
      this.#handleVariantSelected
    );

    this.skioPlanPicker?.removeEventListener(
      "skio:plan-picker:update",
      this.#handleSkioPlanPickerUpdate
    );
  }

  /**
   * Handles the skio plan picker update event.
   * @param {CustomEvent} event - The skio plan picker update event.
   */
  #handleSkioPlanPickerUpdate = (event) => {
    const isSubscription = event.detail.skio.isSubscription;
    const servingInfo =
      this.refs.servingInfo instanceof HTMLElement
        ? this.refs.servingInfo
        : null;
    const subServingInfo = this.closestSection?.querySelectorAll(
      `[data-sub-serving-info-variant-id]`
    );
    const otpServingInfo = this.closestSection?.querySelectorAll(
      `[data-otp-serving-info-variant-id]`
    );

    subServingInfo?.forEach((el) => {
      el.classList.toggle("hidden", !isSubscription);
    });
    otpServingInfo?.forEach((el) => {
      el.classList.toggle("hidden", isSubscription);
    });
  };

  /**
   * Handles the variant selected event.
   * @param {VariantSelectedEvent} event - The variant selected event.
   */
  #handleVariantSelected = (event) => {
    console.log("variantSelected", event.detail);
  };

  /**
   * Handles the variant update event.
   * Updates price, checks for unavailable variants, and updates product URL.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    console.log("variantUpdate", event.detail);
    const servingInfo = this.refs.servingInfo;
    const servingInfoVariantId =
      servingInfo instanceof HTMLElement
        ? servingInfo.querySelector(
            `[data-serving-info-variant-id="${event.detail.resource.id}"]`
          )
        : null;

    servingInfo instanceof HTMLElement
      ? servingInfo
          .querySelectorAll(`[data-serving-info]`)
          .forEach((variant) => {
            variant.classList.add("hidden");
          })
      : null;

    servingInfoVariantId?.classList.remove("hidden");
  };

  /**
   * Updates the DOM with a new price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice(event) {
    const priceContainer = this.querySelectorAll(
      `product-price [ref='priceContainer']`
    )[1];
    const newPriceElement = event.detail.data.html.querySelector(
      `product-price [ref='priceContainer']`
    );

    if (newPriceElement && priceContainer) {
      morph(priceContainer, newPriceElement);
    }
  }
}

if (!customElements.get("serving-info")) {
  customElements.define("serving-info", ServingInfo);
}
